import Vue from 'vue'

const mutations = {
  addSmallProduct(state, product) {
    Vue.set(state.products5R, [product.id], {
      id: product.id,
      name: product.name,
      price: '',
    })
  },
  addMiddleProduct(state, product) {
    Vue.set(state.products6R, [product.id], {
      id: product.id,
      name: product.name,
      price: '',
    })
  },
  addLargeProduct(state, product) {
    Vue.set(state.products8R, [product.id], {
      id: product.id,
      name: product.name,
      price: '',
    })
  },
  addCreativeProduct(state, product) {
    Vue.set(state.productsCreative, [product.id], {
      id: product.id,
      name: product.name,
      price: '',
    })
  },
  //step1
  changeSelectedCountry(state, country) {
    state.selectedCountry = country
  },
  changeSelectedUser(state, user) {
    state.selectedUser = user
  },
  changeSelectedDistributor(state, distributor) {
    state.selectedDistributor = distributor
  },
  changeStartDate(state, startDate) {
    state.startDate = startDate
  },
  changeTestPeriod(state, testPeriod) {
    state.testPeriod = testPeriod
  },
  changeLogoPath(state, logoPath) {
    state.logoPath = logoPath
  },
  addChange(state, change) {
    state.changes.push(change)
  },
  removeChange(state, change) {
    const index = state.changes.findIndex(eChange => eChange.id === change.id)
    state.changes.splice(index, 1)
  },
  updateChange(state, change) {
    const index = state.changes.findIndex(eChange => eChange.id === change.id)
    state.changes[index].date = change.date
    state.changes[index].printers = change.printers
    state.changes[index].contract = change.contract
  },
  //step2
  changeName(state, name) {
    state.name = name
  },
  changeType(state, type) {
    state.type = type
  },
  changeSalesName(state, name) {
    state.sales.name = name
  },
  changeSalesPhone(state, phone) {
    state.sales.phone = phone
  },
  changeSalesEmail(state, email) {
    state.sales.email = email
  },
  changeMarketingName(state, name) {
    state.marketing.name = name
  },
  changeMarketingPhone(state, phone) {
    state.marketing.phone = phone
  },
  changeMarketingEmail(state, email) {
    state.marketing.email = email
  },
  changeStoresNumber(state, number) {
    state.stores.number = number
  },
  changeStoresDescription(state, description) {
    state.stores.description = description
  },
  changeStoresPotentialRollouts(state, potentialRollouts) {
    state.stores.potentialRollouts = potentialRollouts
  },
  addDistributerFile(state, file) {
    state.distributorFiles.push(file)
  },
  addKeyAccountFile(state, file) {
    state.keyAccountFiles.push(file)
  },
  removeFile(state, file) {
    let key = ''
    if (file.type === 'distri_add') {
      key = 'distributorFiles'
    } else {
      key = 'keyAccountFiles'
    }
    const index = state[key].findIndex(eFile => eFile.id === file.id)
    state[key].splice(index, 1)
  },
  //step3
  changeEquipment(state, equipment) {
    const index = state.equipment.indexOf(equipment)
    index === -1 ? state.equipment.push(equipment) : state.equipment.splice(index, 1)
  },

  changeSmallPrinters(state, payload) {
    const index = state[payload.key].smallPrinters.indexOf(payload.value)
    index === -1 ? state[payload.key].smallPrinters.push(payload.value) : state[payload.key].smallPrinters.splice(index, 1)
  },
  changeSmallPrintersNew(state, payload) {
    state[payload.key].smallPrintersNew[payload.printer] = payload.value
  },
  changeSmallPrintersRefurbished(state, payload) {
    state[payload.key].smallPrintersRefurbished[payload.printer] = payload.value
  },
  changeLargePrinters(state, payload) {
    const index = state[payload.key].largePrinters.indexOf(payload.value)
    index === -1 ? state[payload.key].largePrinters.push(payload.value) : state[payload.key].largePrinters.splice(index, 1)
  },
  changeLargePrintersNew(state, payload) {
    state[payload.key].largePrintersNew[payload.printer] = payload.value
  },
  changeLargePrintersRefurbished(state, payload) {
    state[payload.key].largePrintersRefurbished[payload.printer] = payload.value
  },

  changeKioskHeadunits(state, headunit) {
    const index = state.kiosk.headunits.indexOf(headunit)
    index === -1 ? state.kiosk.headunits.push(headunit) : state.kiosk.headunits.splice(index, 1)
  },
  changeKioskHeadunitsNew(state, payload) {
    state.kiosk.headunitsNew[payload.headunit] = payload.value
  },
  changeKioskHeadunitsRefurbished(state, payload) {
    state.kiosk.headunitsRefurbished[payload.headunit] = payload.value
  },
  changeKioskCabinets(state, cabinet) {
    const index = state.kiosk.cabinets.indexOf(cabinet)
    index === -1 ? state.kiosk.cabinets.push(cabinet) : state.kiosk.cabinets.splice(index, 1)
  },
  changeKioskCabinetsNew(state, payload) {
    state.kiosk.cabinetsNew[payload.cabinet] = payload.value
  },
  changeKioskCabinetsRefurbished(state, payload) {
    state.kiosk.cabinetsRefurbished[payload.cabinet] = payload.value
  },
  changeApexHeadunitsNew(state, headunits) {
    state.apex.headunitsNew = headunits
  },
  changeApexHeadunitsRefurbished(state, headunits) {
    state.apex.headunitsRefurbished = headunits
  },
  changeApexCabinets(state, payload) {
    state.apex.cabinets[payload.cabinet] = payload.value
  },

  changeConnection(state, connection) {
    const index = state.standalone.connections.indexOf(connection)
    index === -1 ? state.standalone.connections.push(connection) : state.standalone.connections.splice(index, 1)
  },
  changeStoresNumber2(state, storesNumber) {
    state.storesNumber = storesNumber
  },
  changeSoftware(state, software) {
    state.software = software
  },
  changeRbm(state, rbm) {
    state.rbm = rbm
  },
  changePrintingDevices(state, printingDevices) {
    state.printingDevices = printingDevices
  },
  //step4
  change5RProducts(state, payload) {
    state.products5R[payload.product].price = payload.value
  },
  change6RProducts(state, payload) {
    state.products6R[payload.product].price = payload.value
  },
  change8RProducts(state, payload) {
    state.products8R[payload.product].price = payload.value
  },
  changeCreativeProducts(state, product) {
    const index = state.productsCreative.indexOf(product)
    index === -1 ? state.productsCreative.push(product) : state.productsCreative.splice(index, 1)
  },
  changeCurrency(state, currency) {
    state.currency = currency
  },
  changeOriginalCurrency(state, originalCurrency) {
    state.originalCurrency = originalCurrency
  },
  changeExchangesTo(state, exchangesTo) {
    state.exchangesTo = exchangesTo
  },
  //step5
  changeCommunicationPOS(state, communication) {
    const index = state.communicationPOS.indexOf(communication)
    index === -1 ? state.communicationPOS.push(communication) : state.communicationPOS.splice(index, 1)
  },
  changeCommunicationSM(state, communication) {
    const index = state.communicationSM.indexOf(communication)
    index === -1 ? state.communicationSM.push(communication) : state.communicationSM.splice(index, 1)
  },
  changeCommunicationKA(state, communication) {
    const index = state.communicationKA.indexOf(communication)
    index === -1 ? state.communicationKA.push(communication) : state.communicationKA.splice(index, 1)
  },
  addTrialPosCommunications(state, communication) {
    state.trialPosCommunications.push(communication)
  },
  addTrialKaCommunications(state, communication) {
    state.trialKaCommunications.push(communication)
  },
  addTrialSmCommunications(state, communication) {
    state.trialSmCommunications.push(communication)
  },
  changeTargetgroup(state, targetgroup) {
    state.targetgroup = targetgroup
  },
  //step6
  changePromoDuringTest(state, promo) {
    const index = state.promosDuringTest.indexOf(promo)
    index === -1 ? state.promosDuringTest.push(promo) : state.promosDuringTest.splice(index, 1)
  },
  changeBrandingGeneral(state, branding) {
    state[branding] = ! state[branding]
  },
  changeCompanyWebsite(state, companyWebsite) {
    state.companyWebsite = companyWebsite
  },
  addRollOutPromotion(state, promotion) {
    state.rollOutPromotions.push(promotion)
  },
  deleteRollOutPromotion(state, promotion) {
    const index = state.rollOutPromotions.findIndex(({id}) => id === promotion.id)
    state.rollOutPromotions.splice(index, 1)
  },
  addTrialPromo(state, promo) {
    state.trialPromos.push(promo)
  },
  //generaldocuments
  addGeneralDocument(state, doc) {
    state.generalDocuments.push(doc)
  },
  removeGeneralDocument(state, doc) {
    const index = state.generalDocuments.findIndex(eDoc => eDoc.id === doc)
    state.generalDocuments.splice(index, 1)
  },
  //generalDocumentsFolder
  addGeneralDocumentsFolder(state, folder) {
    state.generalDocumentsFolders.push(folder)
  },
  removeGeneralDocumentsFolder(state, folder) {
    const index = state.generalDocumentsFolders.findIndex(eFolder => eFolder.id === folder.id)
    state.generalDocumentsFolders.splice(index, 1)
  },
  //dragandrop
  startDrag(state, { jsDocElement, domDocElement }) {
    state.drag = true
    state.dragDoc = jsDocElement
  },
  endDrag(state) {
    state.docElement = null
    state.drag = false
  },
  addDragedDocumentInFolder(state, folder) {
    state.dragDoc.document_folder_id = folder.id
    folder.documents.push(state.dragDoc)
    // state.dragDomDoc.parent('.document-element').remove()
  },
}

export default mutations;



// WEBPACK FOOTER //
// ./resources/js/store/mutations.js